import React from 'react';
import style from './requestItem.module.scss';
import Indicator from 'components/adminList/components/indicator/indicator';
import UserData from 'components/adminList/components/userData/userData';
import Button from 'controls/buttons/submit';

export default function RequestItem() {
  return (
    <div className={'adminListItem'}>
      <Indicator bgColor={'#FF6F97'}></Indicator>
      <span className={style.type}>Заявка на регистрацию</span>
      <div className={'vertical'}></div>
      <UserData></UserData>
      <div className={style.buttons}>
        <Button className={style.accept}>Принять</Button>
        <Button
          className={style.dismiss}
          wrapper={{
            className: style.dismissWrapper,
          }}
        >
          Отклонить
        </Button>
      </div>
    </div>
  );
}
